import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { SupportedLanguage } from '@/lib/i18n/config'

export type ThemeMode = 'light' | 'dark' | 'system'

interface UiState {
  theme: ThemeMode
  language: SupportedLanguage
  sidebarOpen: boolean
  setTheme: (theme: ThemeMode) => void
  setLanguage: (language: SupportedLanguage) => void
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
}

/**
 * Client-only UI state. Server data belongs in TanStack Query, not here —
 * see CLAUDE.md ("State management").
 */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'light',
      language: 'hu',
      sidebarOpen: false,
      setTheme: (theme) => {
        set({ theme })
      },
      setLanguage: (language) => {
        set({ language })
      },
      setSidebarOpen: (open) => {
        set({ sidebarOpen: open })
      },
      toggleSidebar: () => {
        set((state) => ({ sidebarOpen: !state.sidebarOpen }))
      },
    }),
    { name: 'corvinus-ui' },
  ),
)
